import React from 'react';
import { arrayOf, string, shape, func, bool } from 'prop-types';
import getVariation from '../../utils/getVariation';
import { Container, Wrapper, Paper, Header, Body, Footer, CloseIcon, Overlay, Option } from './attribute-select.styles';

const AttributeSelect = ({
  label,
  values,
  current,
  selected,
  type,
  variations,
  onChange,
  onClose,
  fullWidth
}) => {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Overlay, {
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Wrapper, {
    fullWidth: fullWidth,
    "data-testid": "attribute-list-wrapper"
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(Header, {
    hasContentLabel: !!label
  }, label, /*#__PURE__*/React.createElement(CloseIcon, {
    onClick: onClose,
    "data-testid": "attribute-close"
  })), /*#__PURE__*/React.createElement(Body, null, values == null ? void 0 : values.map((value, index) => {
    const variation = getVariation(variations, value);
    return /*#__PURE__*/React.createElement(Option, {
      key: `${value}-${index}`,
      value: value,
      type: type,
      checked: selected && current === value,
      disabled: !(variation != null && variation.isAvailable) && !(variation != null && variation.available),
      onChange: onChange
    }, value);
  })), /*#__PURE__*/React.createElement(Footer, null))));
};

process.env.NODE_ENV !== "production" ? AttributeSelect.propTypes = {
  label: string,
  values: arrayOf(string),
  current: string,
  selected: bool,
  type: string,
  variations: arrayOf(shape({
    value: string,
    type: string,
    image: string,
    label: string,
    id: string
  })),
  onChange: func,
  onClose: func,
  fullWidth: bool
} : void 0;
export default AttributeSelect;